import { render, staticRenderFns } from "./input-owner-legal-entity.vue?vue&type=template&id=df64a672"
import script from "./input-owner-legal-entity.vue?vue&type=script&lang=js"
export * from "./input-owner-legal-entity.vue?vue&type=script&lang=js"
import style0 from "./input-owner-legal-entity.vue?vue&type=style&index=0&id=df64a672&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports